export const getMonths = (type: 'short' | 'long' = 'short', locale = 'en-US') => {
  return Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString(locale, { month: type }),
  );
};

export const getMonthName = (dateString: string, type: 'short' | 'long') =>
  new Date(dateString).toLocaleString(globalThis.navigator.language, { month: type });

type DataItem = {
  label: string;
  [key: string]: any;
};

export const getXAxisMonthLabels = (
  data: DataItem[],
  type: 'short' | 'long' = 'short',
  displayYear: boolean = true,
) => {
  return data.map((item, index) => {
    const date = new Date(item.label);
    const monthName = getMonthName(item.label, type);
    const year = date.getFullYear();

    const isJanuary = date.getMonth() === 0;
    const hasDataFromPreviousMonth = index > 0;
    const shouldAddYear = isJanuary && hasDataFromPreviousMonth && displayYear;

    return `${monthName}\n${shouldAddYear ? year : ''}`;
  });
};
